export enum UserApplications {
  ADMIN = 'admin',
  PUBLIC = 'public',
  AGENT = 'agent',
  OWNER = 'owner',
}
